<div class="pdf-generator-section">
  <div class="filters-card">
    <div class="filters-header">
      <h3>Generisanje PDF izvještaja o kretanju cijena</h3>
    </div>

    <form [formGroup]="filterForm" class="filters-form">
      <div class="filter-row">
        <div class="filter-field">
          <label>Država *</label>
          <dx-select-box formControlName="drzava" [dataSource]="drzavaOptions" displayExpr="text" valueExpr="value"
            placeholder="Odaberite državu">
          </dx-select-box>
        </div>

        <div class="filter-field">
          <label>Datum od *</label>
          <dx-date-box formControlName="dateFrom" type="date" displayFormat="dd.MM.yyyy" placeholder="Datum od">
          </dx-date-box>
        </div>

        <div class="filter-field">
          <label>Datum do *</label>
          <dx-date-box formControlName="dateTo" type="date" displayFormat="dd.MM.yyyy" placeholder="Datum do">
          </dx-date-box>
        </div>
      </div>

      <div class="filter-row">
        <div class="filter-field">
          <label>Artikl *</label>
          <dx-select-box formControlName="artikal" [dataSource]="artikli" displayExpr="artikl1" valueExpr="id"
            placeholder="Odaberite artikl" [searchEnabled]="true" (onValueChanged)="onArtiklChange($event)">
          </dx-select-box>
        </div>

        <div class="filter-field opis-field">
          <label>Opisi (opciono)</label>
          <dx-tag-box [dataSource]="opisi" displayExpr="opis" valueExpr="id" placeholder="Odaberite opise"
            [searchEnabled]="true" [value]="selectedOpisi" (onValueChanged)="onOpisChange($event)">
          </dx-tag-box>
          <!-- <small class="hint">Ako ne odaberete nijedan opis, biće korišteni svi opisi</small> -->
        </div>

        <div class="filter-field add-button-field">
          <label>&nbsp;</label>
          <dx-button text="Dodaj u PDF" type="default" icon="plus" (onClick)="addToPdfList()"
            [disabled]="!filterForm.get('artikal')?.value">
          </dx-button>
        </div>
      </div>
    </form>
  </div>

  <!-- Selected Items List -->
  <div class="selected-items-card" *ngIf="pdfInputs.length > 0">
    <div class="selected-header">
      <h3>Artikli za PDF generisanje</h3>
      <dx-button text="Obriši listu" type="danger" icon="trash" (onClick)="clearList()">
      </dx-button>
    </div>

    <dx-data-grid [dataSource]="pdfInputs" [showBorders]="true" [showRowLines]="true">

      <dxi-column caption="Artikl" [width]="200" cellTemplate="artiklTemplate">
      </dxi-column>

      <dxi-column caption="Opisi" cellTemplate="opisiTemplate">
      </dxi-column>

      <dxi-column caption="Akcije" [width]="100" cellTemplate="actionsTemplate">
      </dxi-column>

      <!-- Templates -->
      <div *dxTemplate="let data of 'artiklTemplate'">
        <span>{{ getArtiklName(data.data.artikl) }}</span>
      </div>

      <div *dxTemplate="let data of 'opisiTemplate'">
        <span>{{ getOpisNames(data.data.opisi) }}</span>
      </div>

      <div *dxTemplate="let data of 'actionsTemplate'">
        <dx-button icon="trash" type="danger" stylingMode="text" (onClick)="removeFromPdfList(data.rowIndex)">
        </dx-button>
      </div>
    </dx-data-grid>

    <div class="generate-section">
      <dx-button text="Generiši PDF" type="success" icon="file" (onClick)="generatePdf()" [disabled]="loading">
      </dx-button>

      <span class="item-count">{{ pdfInputs.length }} artikla dodato</span>
    </div>
  </div>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="pdfInputs.length === 0">
    <div class="empty-content">
      <i class="icon dx-icon-file"></i>
      <h4>Nema artikala za PDF generisanje</h4>
      <p>Dodajte artikle iznad kako biste generisali PDF izvještaj</p>
    </div>
  </div>

  <dx-load-panel [visible]="loading" [showIndicator]="true" [showPane]="true" shadingColor="rgba(0, 0, 0, 0.4)">
  </dx-load-panel>
</div>